import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Label, Button, Input } from 'reactstrap';
import { ArrowUpCircle } from 'react-feather';
import FileUploaderSingle from '@components/input/FileUploaderSingle';
import api from '../../../../../../graphql/api';
import ReactAudioPlayer from 'react-audio-player';
import toast from 'react-hot-toast';
import ToastSuccess from '@components/toast/ToastSuccess';

const avatarDefault =
  require('@src/assets/images/avatars/avatar-blank.png').default;

function AudioComponent({ handleChange, values }) {
  const [avatar, setAvatar] = useState(
    values.cover ? values.cover : avatarDefault
  );
  const [progress, setProgress] = useState({
    per: 0,
    text: '0%',
    started: false
  });

  const [progress2, setProgress2] = useState({
    per: 0,
    text: '0%',
    started: false
  });

  const handleUpdateState = (value, name) => {
    const e = {
      target: {
        name,
        value
      }
    };
    handleChange(e);
  };

  const axiosUpload = async (files, type = 'audio') => {
    const data = new FormData();
    data.append('file', files[0]);
    const config = {
      onUploadProgress(progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded / progressEvent.total) * 100
        );
        const text = `${percentCompleted}%`;

        if (type === 'audio') {
          setProgress({
            per: percentCompleted,
            text,
            started: true
          });
        } else {
          setProgress2({
            per: percentCompleted,
            text,
            started: true
          });
        }
      }
    };

    return api.post('/activity/file-upload', data, config);
  };

  const handleFileUpload = async (files) => {
    try {
      const res = (await axiosUpload(files, 'audio')).data;
      toast((t) => <ToastSuccess t={t} message={'Audio subido con exito'} />);
      handleUpdateState(res.uri, 'audio');
    } catch (e) {}
  };

  const handleImgReset = () => {
    setAvatar(avatarDefault);
    handleUpdateState('', 'cover');
  };

  const onChange = async (e) => {
    const reader = new FileReader(),
      files = e.target.files;
    reader.onload = function () {
      setAvatar(reader.result);
    };
    reader.readAsDataURL(files[0]);

    const res = (await axiosUpload(files, 'cover')).data;
    toast((t) => <ToastSuccess t={t} message={'Imagen subida con exito'} />);
    handleUpdateState(res.uri, 'cover');
  };

  const handleReset = () => {
    handleUpdateState('', 'audio');
  };

  return (
    <Row lg={12} className="mb-1">
      <Col md={4}>
        <FileUploaderSingle
          handleSubmit={handleFileUpload}
          accept=".mp3"
          show={!values.audio}
          reset={handleReset}
        >
          <div
            style={{
              width: 366,
              height: 198,
              background: '#F7F7F7'
            }}
            className="position-relative"
          >
            <span
              className="position-absolute fw-bolder top-50 start-50 translate-middle d-flex flex-column jusity-content-center align-items-center"
              style={{
                color: '#6D6B7B',
                fontSize: 14
              }}
            >
              <ArrowUpCircle
                size={36}
                color="#B9B9C3"
                style={{
                  marginBottom: 10
                }}
              />
              <span>Subir .mp3</span>
            </span>
            {progress.started && (
              <div
                className="progress position-absolute"
                style={{ width: '100%', height: 15, bottom: 0 }}
              >
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    background: '#4DFF84',
                    width: `${progress.text}`
                  }}
                  aria-valuenow={progress.per}
                  aria-valuemin={0}
                  aria-valuemax={100}
                >
                  {progress.text}
                </div>
              </div>
            )}
          </div>
        </FileUploaderSingle>
        {values.audio && <ReactAudioPlayer src={values.audio} controls />}
      </Col>
      <Col md={4}>
        <div className="d-flex">
          <div className="me-25">
            <img
              className="rounded me-50"
              src={avatar}
              alt="Generic placeholder image"
              height="200"
              width="200"
            />
            <div className="d-flex align-items-center justify-content-center mt-75 ms-1">
              <Row>
                <Col md={12}>
                  {progress2.started && (
                    <div
                      className="progress mt-2 mb-2"
                      style={{ width: '100%' }}
                    >
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          background: '#4DFF84',
                          width: `${progress2.text}`
                        }}
                        aria-valuenow={progress2.per}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        {progress2.text}
                      </div>
                    </div>
                  )}
                </Col>
                <Col>
                  <Button
                    tag={Label}
                    className="mb-75 me-75"
                    size="sm"
                    color="primary"
                  >
                    Subir
                    <Input
                      type="file"
                      onChange={onChange}
                      hidden
                      accept=".jpg,.jpeg,.png"
                    />
                  </Button>
                  <Button
                    className="mb-75"
                    color="danger"
                    size="sm"
                    outline
                    onClick={handleImgReset}
                  >
                    Eliminar
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
}

AudioComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired
};

export default AudioComponent;
